import shiftService from '@/services/shift.service';
import { SET_SHIFTS } from './type.mutation';

const state = {
  shifts: [],
};

/* eslint-disable no-param-reassign */
const mutations = {
  [SET_SHIFTS](_state, payload) {
    _state.shifts = payload;
  },
};

const actions = {
  getShifts({ commit }, { clinicId, from, to }) {
    return shiftService
      .getShifts({ clinicId, from, to })
      .then((response) => {
        if (!response.ok) {
          throw new Error(response.statusText || 'Error');
        }
        commit(SET_SHIFTS, response.data);
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  upsertShirt({ commit }, {
    clinicId, shiftConfigId, shiftDate, providers,
  }) {
    return shiftService
      .upsertShirt({
        clinicId, shiftConfigId, shiftDate, providers,
      })
      .then((response) => {
        if (!response.ok) {
          throw new Error(response.statusText || 'Error');
        }
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  getAvailableShifts({ commit }, { clinicId, shiftConfigId, shiftDate }) {
    return shiftService.getAvailableShifts({ clinicId, shiftConfigId, shiftDate })
      .then((response) => {
        if (!response.ok) {
          throw new Error(response.statusText || 'Error');
        }
        return response.data;
      })
      .catch((err) => {
        throw err;
      });
  },
  getAvailableShiftsByProvider({ commit }, { clinicId, shiftDate, id }) {
    return shiftService.getAvailableShiftsByProvider({ clinicId, shiftDate, id })
      .then((response) => {
        if (!response.ok) {
          throw new Error(response.statusText || 'Error');
        }
        return response.data;
      })
      .catch((err) => {
        throw err;
      });
  },
};

const getters = {
  all: _state => _state.shifts,
};

export default {
  namespaced: true,
  actions,
  state,
  mutations,
  getters,
};
